import { EntitySwitch, isKind } from '@backstage/plugin-catalog';
import { apiPage } from './layouts/apiPage';
import { componentPage } from './layouts/componentPage';
import { defaultEntityPage } from './layouts/defaultEntityPage';
import { groupPage } from './layouts/groupPage';
import { systemOrDomainPage } from './layouts/systemOrDomainPage';
import { userPage } from './layouts/userPage';

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')}>
      {' '}
      {componentPage}{' '}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('api')}> {apiPage} </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('group')}> {groupPage} </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('user')}> {userPage} </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('system')}>
      {' '}
      {systemOrDomainPage}{' '}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('domain')}>
      {' '}
      {systemOrDomainPage}{' '}
    </EntitySwitch.Case>
    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
